<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :width="'60%'"
        height="auto"
        :TitleWindow="$t('PostPayment.Manual.MultiAdjTitle')"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            {
                text: $t('Shared.Save'),
                variant: 'primary',
                action: emitEventOK
            }
        ]"
        @Close="close"
    >
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                    v-on:click="addHandler"
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-bind:Name="'btn_add_multi-adj'"
                >
                </MdButton>
            </b-col>
        </b-row>

        <b-row>
            <b-col sm="12" lg="12" md="12">
                <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="false"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :RowClick="rowClick"
                    v-bind:VisibleDeleteIcon="true"
                    :deleteIconEvent="deleteHandler"
                    v-bind:VisibleEditIcon="true"
                    :editIconEvent="editHandler"
                >
                </MdTablePaginationClient>
            </b-col>
        </b-row>

        <insurance-multi-adj-payment-posting-modal
            :visible.sync="dialogVisible"
            v-model="editableItem"
            :editMode="editableItemIndex !== -1"
            @ok="saveHandler"
        ></insurance-multi-adj-payment-posting-modal>
    </BaseModal>
</template>

<script>
import Utils from '@/common/utils.js';
import validationMixin from '@/common/validationMixin';
import ShowMessage from '@/components/messages/ShowMessage.js';
import InsuranceMultiAdjPaymentPostingModal from './insMultiAdjPaymentPostingModal.vue';

export default {
    name: 'InsuranceMultiAdjPaymentPostingListingModal',
    components: { InsuranceMultiAdjPaymentPostingModal },
    mixins: [validationMixin, ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            modalId: `modal-${Utils.generateUUID()}`,
            emitCloseEvent: false,
            items: this.value ? [...this.value] : [],
            editableItem: null,
            editableItemIndex: -1,
            dialogVisible: false,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 5,
            fields: [
                {
                    key: 'payCode',
                    sortable: true,
                    label: this.$t('PostPayment.PayCode'),
                    class: 'text-left'
                },
                {
                    key: 'adjAmt',
                    sortable: true,
                    label: this.$t('PostPayment.Manual.Adj'),
                    class: 'text-right'
                },
                {
                    key: 'reasonNo',
                    sortable: true,
                    label: this.$t('PostPayment.ReasonNo'),
                    class: 'text-left'
                }
            ]
        };
    },
    computed: {
        totalRows() {
            return this.items.length;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.items = newVal ? [...newVal] : [];
        }
    },
    methods: {
        resetData() {
            this.items = this.value ? [...this.value] : [];
            this.editableItem = null;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();
            this.$emit('close');
        },

        emitEventOK() {
            this.$emit('update', this.items);
            this.resetData();
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.resetData();
                this.emitCloseEvent = false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        addHandler() {
            this.editableItemIndex = -1;
            this.editableItem = null;
            this.dialogVisible = true;
        },

        editHandler(item) {
            this.editableItemIndex = this.items.indexOf(item);
            this.editableItem = item;
            this.dialogVisible = true;
        },

        saveHandler(item) {
            if (this.editableItemIndex === -1) {
                this.items.push(item);
            } else {
                this.$set(this.items, this.editableItemIndex, { ...item });
            }
        },

        deleteHandler(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('PostPayment.Manual.MultiAdjTitle'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        const indexOf = this.items.indexOf(row);

                        if (indexOf !== -1) {
                            this.items.splice(indexOf, 1);
                        }
                    }
                });
        },

        perPageFunction() {},
        pageChanged() {},
        rowClick() {}
    }
};
</script>
